import merge from 'classnames';

import { SvgIconContainer } from '@/components/generic/SvgIconContainer';

import { SvgIconContainerIconProps } from '../types';

export const IconWarningV3 = ({ classes = {}, ...containerProps }: SvgIconContainerIconProps) => (
  <SvgIconContainer role="img" {...containerProps} className={merge(classes.container)}>
    <svg
      className={merge(classes.icon)}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M8.00016 2L14.6668 14H1.3335L8.00016 2ZM8.00016 4.66667L3.55572 12.6667H12.4446L8.00016 4.66667Z"
        fill="#101820"
        fillRule="evenodd"
      />
      <path d="M7.3335 6.66667H8.66683V10H7.3335V6.66667Z" fill="#101820" />
      <path d="M7.3335 10.6667H8.66683V12H7.3335V10.6667Z" fill="#101820" />
    </svg>
  </SvgIconContainer>
);
